import { useCallback, useEffect, useRef, type PointerEvent } from "react";
import type { FuseNavItemType } from "../../types/FuseNavItemType";

// ------------------------------- CONSTANTS -------------------------------
const ESPERA_HOVER_MS = 100;

// ------------------------------- FUNCTIONS -------------------------------
export default function useIntencaoNavegacao(
	item: Readonly<FuseNavItemType>,
	aoAnteciparItem?: (item: FuseNavItemType) => void,
) {
	const timer = useRef<ReturnType<typeof globalThis.setTimeout> | undefined>(undefined);
	const disponivel = Boolean(
		aoAnteciparItem &&
			item.hasPermission &&
			!item.hidden &&
			!item.disabled &&
			item.type === "item" &&
			!item.children?.length &&
			item.url?.startsWith("/") &&
			!item.url.startsWith("//"),
	);

	// Identidade estável para a limpeza do recurso no efeito.
	const cancelar = useCallback(() => {
		globalThis.clearTimeout(timer.current);
		timer.current = undefined;
	}, []);

	useEffect(() => cancelar, [cancelar, disponivel, item.url, aoAnteciparItem]);

	function antecipar() {
		cancelar();
		if (disponivel) aoAnteciparItem(item);
	}

	function aoEntrar(event: PointerEvent<HTMLElement>) {
		if (!disponivel || event.pointerType === "touch") return;
		cancelar();
		timer.current = globalThis.setTimeout(antecipar, ESPERA_HOVER_MS);
	}

	function aoPressionar(event: PointerEvent<HTMLElement>) {
		if (event.pointerType === "touch") antecipar();
	}

	return { onPointerEnter: aoEntrar, onPointerLeave: cancelar, onFocus: antecipar, onPointerDown: aoPressionar };
}
